import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminDashboard from './components/AdminDashboard';
import { getApiUrl } from './utils/config';

const API = getApiUrl();

const AdminTestPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initAdmin = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No token found - please login first');
          setLoading(false);
          return;
        }

        // Set axios headers
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // Get user profile
        const response = await axios.get(`${API}/auth/me`);
        const userData = response.data;

        console.log('User data:', userData);

        if (userData.role === 'admin' || userData.role === 'owner') {
          setUser(userData);
        } else {
          setError(`Access denied. User role: ${userData.role} (need admin or owner)`);
        }
      } catch (err) {
        console.error('Admin init error:', err);
        setError(`Error: ${err.response?.data?.detail || err.message}`);
      }
      setLoading(false);
    };

    initAdmin();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading admin panel...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <h3 className="text-red-800 font-bold text-lg mb-2">Admin Access Error</h3>
          <p className="text-red-700 mb-4">{error}</p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6">
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Direct Admin Dashboard Test</h1>
          <p className="text-gray-600">Testing admin functions directly</p>
          <div className="mt-2 text-sm text-blue-600">
            User: {user.email} | Role: {user.role} | Token: {localStorage.getItem('token') ? 'Present' : 'Missing'}
          </div>
        </div>
        
        <AdminDashboard
          user={user}
          onBack={() => window.location.href = '/'}
        />
      </div>
    </div>
  );
};

export default AdminTestPage;